var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFloating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 320 320",
    style: {
      enableBackground: "new 0 0 320 320"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M304,227.8l-48.8-23.1L166,162.6c-1.8-0.9-3.9-1.3-6-1.3s-4.2,0.4-6,1.3l-89.1,42.2l-48.9,23c-3.4,1.6-5.5,4.5-5.5,7.6 s2.1,6,5.5,7.6l138,65.2c1.8,0.9,3.9,1.3,6,1.3s4.2-0.4,6-1.3L304,243c3.4-1.6,5.5-4.5,5.5-7.6S307.4,229.4,304,227.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6,180.4l25.3,11.9c4.2,2,9.3,0.2,11.3-4s0.2-9.3-4-11.3L29,165.5l129.1-61c1.2-0.6,2.9-0.6,4.1,0l129.1,61L267.1,177 c-4.2,2-6,7-4,11.3c2,4.2,7.1,6,11.3,4l25.3-12c6.2-2.9,10-8.6,10-14.8s-3.8-11.9-10-14.8l-130-61.4V41.6 c7.3,7.2,16.4,16.3,24.8,24.9c3.7,3.7,9.7,3.8,13.4,0.1c3.7-3.7,3.8-9.7,0.1-13.4c-27.2-27.7-37.3-37.4-42.3-40.9 c-0.4-0.3-0.8-0.5-1.2-0.8c-1.9-1.1-3-1.1-4.4-1.1c-1.6,0-2.8,0-5,1.4c-0.2,0.1-0.3,0.2-0.5,0.3c-4.9,3.3-14.6,13-41.4,41.1 c-3.6,3.8-3.5,9.8,0.3,13.4c1.8,1.7,4.2,2.6,6.5,2.6c2.5,0,5-1,6.9-2.9c8-8.4,16.6-17.2,23.6-24.4v47.4l-130,61.4 c-6.2,2.9-10,8.6-10,14.8C10.5,171.8,14.3,177.4,20.6,180.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFloating);
export default __webpack_public_path__ + "static/media/Icon_Floating.63470c592bdb091efb488795813fe20c.svg";
export { ForwardRef as ReactComponent };